export const SITE_CONFIG = {
    FAVORITES_KEY: 'favorites',
    SELECTED_SITE_KEY: 'selectedSite'
}

export class SiteSessionStorage {
    get favorites() {
        return JSON.parse(sessionStorage.getItem(SITE_CONFIG.FAVORITES_KEY));
    }

    get selectedSite() {
        return JSON.parse(sessionStorage.getItem(SITE_CONFIG.SELECTED_SITE_KEY));
    }

    setFavorites(siteIds) {
        sessionStorage.setItem(SITE_CONFIG.FAVORITES_KEY, JSON.stringify(siteIds));
    }

    setFavorite(siteId) {
        let favorites = JSON.parse(sessionStorage.getItem(SITE_CONFIG.FAVORITES_KEY));
        if (favorites !== null) {
            favorites.push(siteId);
        } else {
            favorites = [siteId];
        }
        sessionStorage.setItem(SITE_CONFIG.FAVORITES_KEY, JSON.stringify(favorites));
    }

    setSelectedSite(site) {
        sessionStorage.setItem(SITE_CONFIG.SELECTED_SITE_KEY, JSON.stringify(site));
    }
}